import React, { useContext } from 'react';
import { Card, Row, Col, Accordion, Button, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const CardHeaderToggle = ({ ...props }) => {
  const {
    eventKey,
    title,
    as,
    style,
    onClick = null,
    isRequired = false,
    isLink = false,
    isLeft = false,
    extraButtons = null,
  } = props;

  const currentEventKey = useContext(AccordionContext); // <-- Will update every time the eventKey changes.
  const toggleOnClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;
  const updatedStyle = { ...style, cursor: 'pointer' };

  return (
    <Card.Header
      as={as}
      style={updatedStyle}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick && onClick instanceof Function) {
          onClick(eventKey);
        } else {
          toggleOnClick();
        }
      }}
    >
      <Row style={{ alignItems: 'center' }}>
        {isLeft ? (
          <>
            <ToggleIcon isLeft={isLeft} isLink={isLink} isCurrentEventKey={isCurrentEventKey} eventKey={eventKey} />
            <ToggleTitle title={title} isRequired={isRequired} isLeft={isLeft} />
            <Col lg={6} md={6} xs={6} className="text-right pr-0 pl-0">
              {extraButtons}
            </Col>
          </>
        ) : (
          <>
            <ToggleTitle title={title} isRequired={isRequired} isLeft={isLeft} />
            <ToggleIcon isLeft={isLeft} isLink={isLink} isCurrentEventKey={isCurrentEventKey} eventKey={eventKey} />
          </>
        )}
      </Row>
    </Card.Header>
  );
};

const ToggleIcon = ({ ...props }) => {
  const expandedClass = 'fa fa-chevron-up ' + (props.isLeft ? 'mr-4' : 'm-0 p-0');
  const collapsedClass = 'fa fa-chevron-down ' + (props.isLeft ? 'mr-4' : 'm-0 p-0');
  const iconColSize = props.isLeft ? 1 : 2;

  return (
    <Col
      lg={iconColSize}
      md={iconColSize}
      xs={iconColSize}
      className={props.isLeft ? 'text-left pl-0' : ' text-right pr-2'}
    >
      <Accordion.Toggle
        as={Button}
        size="lg"
        variant={props.isLink ? 'link' : null}
        eventKey={props.eventKey}
        className={props.isCurrentEventKey ? expandedClass : collapsedClass}
      />
    </Col>
  );
};

const ToggleTitle = ({ ...props }) => {
  const { title, isRequired, isLeft } = props;

  return (
    <Col lg={isLeft ? 5 : 10} md={isLeft ? 5 : 10} xs={isLeft ? 5 : 10}>
      {title}
      {isRequired ? <b className="text-danger"> (REQUIRED)</b> : null}
    </Col>
  );
};

export const AccordionHeaderToggle = ({ eventKey, title, as, style }) => {
  const currentEventKey = useContext(AccordionContext); // <-- Will update every time the eventKey changes.
  const toggleOnClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <Card.Header as={as} style={style}>
      <Row style={{ alignItems: 'center' }}>
        <Col lg={8} md={8} xs={8}>
          {title}
        </Col>
        <Col lg={4} md={4} xs={4} className="text-right">
          <Accordion.Toggle
            as={Button}
            onClick={toggleOnClick}
            size="lg"
            variant="link"
            eventKey="0"
            className={isCurrentEventKey ? 'fa fa-chevron-up ml-4' : 'fa fa-chevron-down ml-4'}
          />
        </Col>
      </Row>
    </Card.Header>
  );
};

AccordionHeaderToggle.propTypes = {
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  as: PropTypes.string,
  style: PropTypes.object,
};

CardHeaderToggle.propTypes = {
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  as: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  isRequired: PropTypes.bool,
};

export default CardHeaderToggle;
